import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

export function useAviator() {
  const [state, setState] = useState(null);
  const [now, setNow] = useState(Date.now());
  const offset = useRef(0);

  const load = useCallback(async () => {
    try {
      const t0 = Date.now();
      const { data } = await api.get("/aviator/state");
      offset.current = new Date(data.server_now).getTime() - (t0 + Date.now()) / 2;
      setState(data);
    } catch {
      /* keep last state */
    }
  }, []);

  useEffect(() => {
    load();
    const id = setInterval(load, 800);
    return () => clearInterval(id);
  }, [load]);

  useEffect(() => {
    let raf;
    const tick = () => { setNow(Date.now()); raf = requestAnimationFrame(tick); };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  const serverNow = now + offset.current;
  const rnd = state?.round;
  let multiplier = rnd?.multiplier || 1;
  let elapsed = 0;
  let countdown = 0;
  if (rnd?.status === "running") {
    elapsed = Math.max(0, (serverNow - new Date(rnd.run_start).getTime()) / 1000);
    multiplier = Math.min(Math.floor(Math.exp(rnd.growth_rate * elapsed) * 100) / 100, rnd.max_multiplier);
  }
  if (rnd?.status === "waiting") {
    countdown = Math.max(0, (new Date(rnd.run_start).getTime() - serverNow) / 1000);
  }
  return { state, load, multiplier, elapsed, countdown };
}
